import React, { useMemo } from "react"
import { StyleSheet } from "react-native"
import { View } from "react-native"
import { theme } from "@common/theme/theme"
import TextM from "@common/components/text/TextM"
import ObjectivesSummaryDisplay from "@common/account/ObjectivesSummaryDisplay"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { ModalSkeleton } from "../common/modals/ModalSkeleton"

export const DiagnosticSummaryModal = ({
    isVisible,
    onClose,
    schoolSubjects,
    user,
    onSubmit,
    isFormulateObjectivesLoading,
    objectivesWithFormulatedGoals,
    objectiveNeeds,
    selectedSession,
    isLoading,
    noHours = false,
}) => {
    const shortName = useMemo(() => {
        const fn = (user?.firstname || "").trim()
        const ln = (user?.lastname || "").trim()
        if (fn && ln) return `${fn} ${ln.charAt(0)}.`
        return user?.display_name || `${fn} ${ln}`.trim()
    }, [user])

    return (
        <ModalSkeleton
            isVisible={isVisible}
            onClose={onClose}
            title="Récapitulatif"
        >
            {/* Infos card */}
            <View style={styles.summaryCard}>
                <TextM fontWeight="Bold" style={{ marginBottom: 2 }}>
                    Élève
                </TextM>
                <TextM style={{ marginBottom: 8 }}>{shortName}</TextM>

                <TextM fontWeight="Bold" style={{ marginBottom: 2 }}>
                    Classe
                </TextM>
                <TextM style={{ marginBottom: 8 }}>
                    {user?.profile?.class || ""}
                </TextM>
            </View>

            {/* Objectives card */}
            <View style={styles.summaryCard}>
                <TextM fontWeight="Bold" style={{ marginBottom: 8 }}>
                    Objectifs pédagogiques
                </TextM>
                <ObjectivesSummaryDisplay
                    objectives={objectivesWithFormulatedGoals || []}
                    schoolSubjects={schoolSubjects || []}
                    objectiveNeeds={objectiveNeeds || []}
                    compact={true}
                    style={{ marginTop: 0 }}
                    isFormulateLoading={isFormulateObjectivesLoading}
                    noHours={noHours}
                />
            </View>

            <View style={styles.summaryCard}>
                <TextM fontWeight="Bold" style={{ marginBottom: 8 }}>
                    Créneau choisi pour le cours découverte
                </TextM>
                <TextM style={{ marginBottom: 8 }} capitalize>
                    {selectedSession?.label}
                </TextM>
            </View>

            <FilledButtonM
                style={{ marginTop: 14, width: "90%", marginBottom: 5 }}
                label="Réserver la séance"
                onPress={onSubmit}
                color={theme.colors.success}
                loading={isLoading}
            />
            <TextM
                color={theme.colors.light}
                fontSize={11}
                wrap
                style={{ marginTop: 2, textAlign: "center" }}
            >
                Vous pourrez modifier ces choix plus tard
            </TextM>
        </ModalSkeleton>
    )
}

const styles = StyleSheet.create({
    summaryCard: {
        backgroundColor: theme.colors.white,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
        padding: 12,
        marginBottom: 12,
    },
})
